
import { sevMeta, SEVERITY_RANK } from "../lib/theme";

const SIZES = {
  xs: { icon: 11, text: "text-[10px] gap-1" },
  sm: { icon: 13, text: "text-xs gap-1.5" },
  md: { icon: 15, text: "text-sm gap-1.5" },
  lg: { icon: 17, text: "text-sm gap-2" },
};



export const bangs = (severity) => "!".repeat(SEVERITY_RANK[severity] || 1);

export function SeverityDots({ level = 1, color, size = "sm", text = "#fff" }) {
  const s = SIZES[size].icon + 3;
  return (
    <span aria-hidden data-level={level} className="shrink-0 inline-flex items-center justify-center rounded-full text-white font-bold leading-none tabular-nums"
      style={{ width: s, height: s, background: color, color: text, fontSize: Math.round(s * 0.62) }}>{level}</span>
  );
}

export default function SeverityMark({ severity, size = "sm", showLabel = true, className = "" }) {
  const s = sevMeta(severity);
  return (
    <span
      data-testid={`severity-mark-${severity || "unknown"}`}
      aria-label={`Priority ${s.level}, ${s.label}`}
      title={`Priority ${s.level} · ${s.label}`}
      className={`inline-flex items-center font-medium leading-none shrink-0 select-none ${SIZES[size].text} ${className}`}
      style={{ color: s.color }}
    >
      <SeverityDots level={s.level} color={s.color} size={size} />
      {showLabel && <span className="whitespace-nowrap">{s.label}</span>}
    </span>
  );
}
